import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/notifications/styles.css';
// import '@mantine/dropzone/styles.css';
import { createTheme, MantineProvider } from '@mantine/core';
import { LoadingOverlayProvider } from './components/LoadingOverlayContext';
import { Notifications } from "@mantine/notifications";

const theme = createTheme({
  colors: {

  },
  breakpoints: {
    xs: "360px",
    sm: "480px",
    md: "768px",
    lg: "960px",
    xl: "1200px",
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
     <MantineProvider theme={theme}>
      <Notifications />
      <LoadingOverlayProvider>
        <Router>
          <App />
        </Router>
      </LoadingOverlayProvider>
    </MantineProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();

